import { tv } from '../tv';

/** Icon tile of a toast; the card itself stays neutral for every tone. */
export const toastVariants = tv({
  slots: {
    root: `pointer-events-auto relative flex w-full flex-col gap-2 overflow-hidden
      rounded-xl bg-zinc-800 py-3.5 ps-4 pe-3 font-brand shadow-xl inset-ring
      inset-ring-zinc-700`,
    tile: 'flex size-8 shrink-0 items-center justify-center rounded-full',
  },
  variants: {
    tone: {
      info: { tile: 'bg-zinc-700 text-zinc-100' },
      success: { tile: 'bg-success-500/15 text-success-500' },
      warning: { tile: 'bg-warning-500/15 text-warning-500' },
      danger: { tile: 'bg-danger-500/15 text-danger-400' },
    },
  },
  defaultVariants: {
    tone: 'info',
  },
});

/**
 * One slot of the stack: the newest toast sits on top, older ones peek out
 * beneath it, smaller and dimmer, so the eye reads "more behind this".
 */
export const toastStackItemVariants = tv({
  base: `col-start-1 row-start-1 origin-top transition duration-200 ease-out
    starting:translate-x-4 starting:opacity-0 motion-reduce:transition-none`,
  variants: {
    depth: {
      0: 'z-30',
      // compact (header-only) toasts sit on the front toast's bottom edge,
      // so they peek out below it however tall the front one is
      1: 'z-20 origin-bottom translate-y-2 scale-95 self-end opacity-70',
      2: 'z-10 origin-bottom translate-y-4 scale-90 self-end opacity-40',
    },
  },
  defaultVariants: {
    depth: 0,
  },
});
